import { Avatar, MCText } from '../basic';
import { Link } from 'react-router-dom';
import React from 'react';
import { lang, userFullName, remFontCss as dRemFontCss, scssVariables, rgba } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

const ShortInfo = ({
  to,
  user = {},
  fullname,
  avatar,
  specialist,
  description,
  note,
  small,
  large,
  medium,
  badges = null,
  style = {},
  styleName,
  vertical = false,
  verticalCenter = false,
  width,
  onlineState,
  remFontCss = dRemFontCss,
  textSize: textSizeProps,
  onClick,
  isDisabledAccount = false
}) => {
  if (!user) return null;
  fullname = fullname || userFullName(user);
  avatar = avatar || user?.avatar;
  specialist = specialist || user.specialist;
  specialist = specialist
    ?.filter((v) => !!LANG_CONST.constants.specialist[v])
    .map((s) => lang.t(LANG_CONST.constants.specialist[s]))
    .join(', ');

  width = width || (small ? 30 : large ? 80 : 50);
  const textSize = textSizeProps || (large ? 22 : medium ? 20 : 18);
  const desSize = large ? 20 : medium ? 18 : 16;

  if (verticalCenter) vertical = true;

  const content = (
    <>
      <Avatar
        text={fullname}
        width={width}
        height={width}
        image={avatar}
        onlineState={onlineState}
      />
      <div
        className={`mc-flex-5-col mc-grow ${verticalCenter ? 'mc-flex-center' : ''}`}
        style={{ minWidth: 0 }}
      >
        <div className={'mc-flex'}>
          <MCText
            size={textSize}
            weight={500}
            style={styleName}
            numberOfLines={1}
            remFontCss={remFontCss}
          >
            {fullname}
          </MCText>
          {badges}
        </div>
        {(description || specialist) && !small && (
          <div
            className={`mc-label-420 ${verticalCenter ? 'mc-text-center' : 'mc-text-truncate'}`}
            style={{
              fontSize: remFontCss(desSize),
              lineHeight: remFontCss(desSize + 6) + 'px'
            }}
          >
            {description || specialist}
          </div>
        )}
        {isDisabledAccount ? (
          <MCText
            label={LANG_CONST.unavailable}
            style={{ color: rgba(scssVariables['colors-mc-orange'], 0.7) }}
            size={18}
          />
        ) : (
          note
        )}
      </div>
    </>
  );

  const className = `mc-flex${vertical ? '-col ' : ''} ${verticalCenter ? 'mc-flex-center' : ''} mc-grow`;

  if (!to)
    return (
      <div className={className} style={{ ...style, minWidth: 0 }} onClick={onClick}>
        {content}
      </div>
    );

  return (
    <Link to={to} className={className} style={{ ...style, minWidth: 0 }}>
      {content}
    </Link>
  );
};

export default ShortInfo;
